export default class MobileMenu {

    constructor() {

        this.settings = {
            el: document.querySelectorAll('.js-mobile-toggle-icon')
        };

        this.bindUIActions();

    }

    bindUIActions() {

        this.settings.el.forEach((icon) => {
            icon.addEventListener('click', (e) => {
                const toggleIcon = icon;
                const parentListItem = toggleIcon.closest('li');
                const accordionItems = parentListItem.querySelectorAll('.js-mobile-accordion-items');

                accordionItems.forEach((items) => {
                    items.classList.toggle('hidden');
                });

                toggleIcon.classList.toggle('rotate-45');
            });
        });

    }

};

new MobileMenu();